/**
 * mapAssets — Catalog of 2012 map render / minimap URLs (AR-06).
 * Pure data; presentation may use URLs as CSS backgrounds (no canvas CORS).
 */

const WIKI = 'https://wiki.leagueoflegends.com/en-us/images';

export const MAP_ASSETS = Object.freeze({
  aram_proving_grounds: Object.freeze({
    id: 'aram_proving_grounds',
    backgroundUrl: `${WIKI}/Proving_Grounds_map.png`,
    minimapUrl: `${WIKI}/The_Proving_Grounds_Minimap.png`,
    silhouette: 'bridge'
  }),
  twisted_treeline_3v3: Object.freeze({
    id: 'twisted_treeline_3v3',
    backgroundUrl: `${WIKI}/Twisted_Treeline_map.png`,
    minimapUrl: `${WIKI}/Twisted_Treeline_Minimap.png`,
    silhouette: 'multi'
  }),
  summoners_rift_5v5: Object.freeze({
    id: 'summoners_rift_5v5',
    backgroundUrl: `${WIKI}/Summoner%27s_Rift_map.png`,
    minimapUrl: `${WIKI}/Summoner%27s_Rift_Minimap.png`,
    silhouette: 'multi'
  }),
  crystal_scar_dominion: Object.freeze({
    id: 'crystal_scar_dominion',
    backgroundUrl: `${WIKI}/Crystal_Scar_map.png`,
    minimapUrl: `${WIKI}/Crystal_Scar_Minimap.png`,
    silhouette: 'ring'
  }),
  test_map: Object.freeze({
    id: 'test_map',
    backgroundUrl: `${WIKI}/Proving_Grounds_map.png`,
    minimapUrl: `${WIKI}/The_Proving_Grounds_Minimap.png`,
    silhouette: 'bridge'
  })
});

export function getMapAssets(mapId) {
  return MAP_ASSETS[mapId] || MAP_ASSETS.aram_proving_grounds;
}
